import React, { useEffect } from 'react';
import { Spinner } from '../theme/primitives';

export const BackDropLoad = ({ wait }) => {
  useEffect(() => {
    if (!wait) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [wait]);

  if (!wait) return null;

  return (
    <div
      role="alertdialog"
      aria-busy="true"
      aria-label="Loading"
      className="
        fixed inset-0 z-[1400] flex items-center justify-center
        bg-black/72 backdrop-blur-md
        animate-[fadeIn_180ms_ease-out]
      "
    >
      <div
        className="
          relative flex flex-col items-center gap-4
          rounded-2xl border border-amber/20 bg-surface-elevated/90
          px-9 py-8
          shadow-dialog
        "
      >
        <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/50 to-transparent" />
        <div className="relative flex h-14 w-14 items-center justify-center">
          <span aria-hidden className="absolute inset-0 rounded-full bg-amber/15 animate-ping" />
          <span aria-hidden className="absolute inset-2 rounded-full bg-amber/8" />
          <Spinner size={28} />
        </div>
        <div className="text-[10.5px] font-bold uppercase tracking-[0.22em] text-amber">
          Please wait
        </div>
      </div>
    </div>
  );
};
